@if (isLoading$ | async) {
  <div class="spinner-overlay">
    <mat-spinner [diameter]="(style$ | async)?.size || 150" [strokeWidth]="(style$ | async)?.thickness || 15" [color]="(style$ | async)?.color || 'primary'" [mode]="'indeterminate'" [class]="(style$ | async)?.spinnerClass || 'gray-spinner'"> </mat-spinner>
    <p class="spinner-message" [class]="(style$ | async)?.messageClass">{{ message$ | async }}</p>
  </div>
}
